import { createSlice } from "@reduxjs/toolkit";

import { getMappingCountApi, getMappingListApi } from "../../reduxApi/admin/MappingReduxApi";
const getMappingListSlice = createSlice({
    name: "MappingList",
    initialState: {
        getMappingList: [],
        getMappingCount: [],
        status: "idle",
    },
    reducers: {
        // Add Mapping
        addMapToList: (state, action) => {
            state.getMappingList.unshift(action.payload);
        },

        // Update Mapping
        updateMapInList: (state, action) => {
            const index = state.getMappingList.findIndex(mapping => mapping.ROWID === action.payload.ROWID);
            if (index !== -1) {
                state.getMappingList[index] = action.payload;
            }
        },

        // Delete Mapping
        deleteMapFromList: (state, action) => {
            const idsToDelete = action.payload; // array of ROWIDs
            state.getMappingList = state.getMappingList.filter(
                (mapping) => !idsToDelete.includes(mapping.ROWID)
            );
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getMappingListApi.fulfilled, (state, action) => {
            state.status = "fulfilled";
            // console.log("getMappingList action", action.payload);
            state.getMappingList = action.payload.data.mappingMiddleware;
            // console.log("getMappingList", state.getMappingList);
        });
        builder.addCase(getMappingCountApi.fulfilled, (state, action) => {
            state.status = "fulfilled";
            // console.log("getMappingList action", action.payload);
            state.getMappingCount = action.payload.data;
            // console.log("getMappingList", state.getMappingList);
        });
    },
});
// export const { deleteOrdersAction, updateOrdersAction, addOrdersAction } = OrdersSlice.actions
export const { addMapToList, updateMapInList, deleteMapFromList } = getMappingListSlice.actions;
export default getMappingListSlice.reducer;
